export const HIGH_RISK_VALUE = 'High Risk';
